export default __webpack_public_path__ + "b27297c148a7ef314ce20bc617a6106b.woff2";